import React from 'react'
import {
    StyledLabelledToggle,
    StyledToggle,
    StyledToggleCheckbox,
    StyledToggleSwitch,
} from '../../buttons/LabelledToggle/LabelledToggle.styled'

export interface LabelledToggleProps {
    checked?: boolean
    onToggle: (value: boolean) => void
    on?: string
    off?: string
    className?: string
    disabled?: boolean
}

export const LabelledToggle: React.FC<LabelledToggleProps> = ({
    onToggle,
    checked = false,
    on = 'on',
    off = 'off',
    className,
    disabled = false,
}) => (
    <StyledToggle className={className}>
        <StyledToggleCheckbox
            type="checkbox"
            checked={checked}
            onChange={() => onToggle(!checked)}
        />
        <StyledLabelledToggle
            disabled={disabled}
            onClick={(e) => {
                e.preventDefault()
                if (disabled) return
                onToggle(!checked)
            }}
        >
            <StyledToggleSwitch disabled={disabled} active={checked}>
                {off}
            </StyledToggleSwitch>
            <StyledToggleSwitch
                disabled={disabled}
                active={checked}
                primary={true}
            >
                {on}
            </StyledToggleSwitch>
        </StyledLabelledToggle>
    </StyledToggle>
)

LabelledToggle.displayName = 'LabelledToggle'
